function ColourSwitch(){

    var self = this;




   self.controller = new ScrollMagic.Controller();


    function topTriggerNav(e){

        if(e.type ==="enter"){

            console.log("---------------- section enter");

           // alert("enter");

            $("#show-menu").addClass("dark");
            //$("#logo").addClass("light");

           // $("#more").removeClass("light");

        } else {


          //  alert("leave");

            // console.log("inlne leave");

            $("#show-menu").removeClass("dark");
           // $("#logo").removeClass("light");

           // $("#more").addClass("light");
        }

    }

    var hashTopID = "#logo-trigger";

    var scene1 = new ScrollMagic.Scene({triggerElement: hashTopID, triggerHook: 'onLeave', offset: -90})

        .on("enter leave", topTriggerNav)


        .addTo(self.controller);





}
ColourSwitch.prototype.destroyScrollTriggers = function (){

    console.log("--------------------- destroyScrollTriggers");

    for (var i = 0; i <  window.sceneArray.length; i++) {

           window.sceneArray[i].remove();

           window.sceneArray[i].destroy(true);

    }
    if (window.controller) {
        window.controller = window.controller.destroy(true);
    }
    window.sceneArray = [];

};
